import type { ApiTypes } from "../../../index";
import { axiosInstance, handleApiError } from "../../../utils";

/**
 * checkout-started operation
 * @param request - The request data
 * @returns Promise resolving to the API response
 */
export const startedCheckout = async ({
  request,
}: {
  request: ApiTypes["checkout-started"]["request"];
}): Promise<ApiTypes["checkout-started"]["response"]> => {
  try {
    const response = await axiosInstance.post<
      ApiTypes["checkout-started"]["response"]
    >(`/api/public/v2025-06/events/checkout/started`, request);
    return response.data;
  } catch (error) {
    handleApiError(error as Error, "Failed to startedCheckout");
    throw error;
  }
};

/**
 * checkout-started operation using navigator.sendBeacon for reliable delivery during page unload
 * @param request - The request data
 * @returns boolean indicating if the beacon was successfully queued
 */
export const startedCheckoutBeacon = ({
  request,
}: {
  request: ApiTypes["checkout-started"]["request"];
}): boolean => {
  try {
    const url = `${axiosInstance.defaults.baseURL}/api/public/v2025-06/events/checkout/started`;

    // Send request body as beacon data
    const blob = new Blob([JSON.stringify(request)], {
      type: "application/json",
    });

    return navigator.sendBeacon(url, blob);
  } catch (error) {
    console.error("Failed to send beacon for startedCheckout:", error);
    return false;
  }
};
